/* eslint-disable react-hooks/exhaustive-deps */
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { formatUserDateTime } from '@/common/utils/timezoneUtils';
import {
    hasKnowledgeChatPermission,
    isDisplayEyeSlashIcon,
    permissionChangeShareRangeStatus,
    displayTagOfThumbAttach,
    handleSelectFilePdf
} from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import {
    generateDetatilTicketTitle,
    viewTicketKnowledgeDetail
} from '@/component/ticketList/handler/TicketHandler';

import { Badge,  Checkbox,  FormControl, FormControlLabel, FormGroup, Popover, Tooltip, Typography } from '@material-ui/core';

import './ListTicketKnowledge.css';
import { onHoverPopoverFootprint } from './handler/FootprintHandler';
import {
    handleClickChecked,
    handleClickShareStatus,
    handleClosePopover,
    isAddtionalViewOrEdit,
    isCheckedChangeStatusOption
} from './handler/ShareStatusKnowledgeHandler';

import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';

import Bookmark from './elements/Bookmark/Bookmark';
import TaggedBookmarkListName from './elements/Bookmark/TaggedBookmarkListName';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ButtonOption from '@/component/common/ButtonOption';
import CopyShareLinkListItem from '@/component/common/CopyShareLinkListItem';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import AttachThumbnailList from '../common/AttachFileThumbnail/components/AttachThumbnailList';
import { isDisplayTicketThumbnail } from '../common/AttachFileThumbnail/handler/attachThumbnailHandler';
import useListTicketOnDemandDisplay from '@/component/multiLanguage/hooks/useListTicketOnDemandDisplay';

const getCorporationByInfo = (affiliationProjectInfo, corporationDetail, ticketKnowledge) => {
    let affiliationOrganizationInfo = {};
    if (affiliationProjectInfo.affiliationOrganization === corporationDetail.id) {
        affiliationOrganizationInfo = corporationDetail;
    } else if (ticketKnowledge.affiliationOrganizationInfo) {
        affiliationOrganizationInfo = ticketKnowledge.affiliationOrganizationInfo;
    }

    return affiliationOrganizationInfo;
};

export default function ListKnowledgeItem(props) {
        // Re-render when the translation dictionary loads/extends so tr() text updates.
        useTranslationSubscription();

        let {
            corporationDetail,
            isViewDelete,
            projectInuseDetail,
            openChatThreadPanel,
            userPermissionView,
            addViewPopover,
            setFootPrintPopover,
            ticketKnowledgeList,
            setUserFootprintList,
            idPopOverFootPrint,
            openPopoverFootPrint,
            footPrintPopover,
            userFootprintList,
            argsCommon,
            addNewPanel,
            setLastUserAction,
            userDetail,
            isProjectManager,
            viewStructure,
            idPopoverShareStatus,
            setShareStatusPopover,
            setOpenShareStatusPopover,
            openShareStatusPopover,
            shareStatusPopover,
            shareStatusData,
            isShowIconPageUnit,
            setPreviousViewStructure,
            setViewStructure,
            isCustomer,
            setFileNamePdfSelect,
            setTriggerSearch,
            fileNamePdfSelect,
            corporationSelectedId,
            setIsOpenModalReloadPage,
            setIsLoading,
            visibilityKnowledgeAtom,
            ticketKnowledge,
        } = {...props};

        // Sử dụng userAtom để lấy thông tin user hiện tại
        const currentUserDetail = useRecoilValue(userAtom);

        // On-demand list translation (MLT-001-F4): resolve the knowledge title to display.
        // Knowledge has no last message (§5.1), so only the title is resolved.
        const originalKnowledgeTitle = Utils.getTitle(ticketKnowledge?.settingTitle)
            ? generateDetatilTicketTitle(ticketKnowledge)
            : tr('[概要 (現在未記入)]');
        const { displayTitle: onDemandKnowledgeTitle } = useListTicketOnDemandDisplay(
            originalKnowledgeTitle,
            null,
            {
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
                // Must match the write-side key (listOnDemandKey in ListTicketKnowledge):
                // ALL_KNOWLEDGE_IN_ORG uses its own key, so viewSelectedId would read the wrong record.
                viewKey: props.listOnDemandKey || props.viewSelectedId,
                ticketId: ticketKnowledge?.id
            }
        );
        
        const [footPrint, setFootPrint] = useState([]);
        const id = addViewPopover ? 'simple-popover' : undefined;
        let isAddtional = isAddtionalViewOrEdit(ticketKnowledge);
        let labelOfButtonShareStatus = isAddtional
            ? `${Constant.KNOWLEDGE_SHARE_STATUS_LABEL}+`
            : Constant.KNOWLEDGE_SHARE_STATUS_LABEL;
        let affiliationProjectInfo = ticketKnowledge?.affiliationProjectInfo;
        let projectName = `${Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            affiliationProjectInfo?.name
        )}`;

        useEffect(() => {
            setFootPrint(ticketKnowledge?.footPrint)
        },[ticketKnowledge.id, ticketKnowledge?.footPrint])

        // get affiliationOrganizationInfo;
        let affiliationOrganizationInfo = getCorporationByInfo(affiliationProjectInfo, corporationDetail, ticketKnowledge)
        let corporationNameSuffixText = Utils.getCorporationNameSuffixText(
            affiliationOrganizationInfo
        );

        projectName = corporationNameSuffixText ? `${projectName} (${corporationNameSuffixText})` : `${projectName}`;
        
        // creator
        let creatorName = `${Utils.getUserNameWithActiveStatus(ticketKnowledge?.creatorInfo)}`;
        let suffixCreatorName = Utils.getCorporationNameSuffixText(
            ticketKnowledge?.creatorInfo?.affiliationOrganizationInfo
        );
      
        creatorName = suffixCreatorName ? `${creatorName} (${suffixCreatorName})` : `${creatorName}`;

        // updator
        let updatorName = `${Utils.getUserNameWithActiveStatus(ticketKnowledge?.updatorInfo)}`;
        let suffixUpdatorName = Utils.getCorporationNameSuffixText(
            ticketKnowledge?.updatorInfo?.affiliationOrganizationInfo
        );

        const dataShareLink = Utils.convertJSONDataToObject(ticketKnowledge?.dataShareLink);
        
        updatorName = suffixUpdatorName ?  `${updatorName} (${suffixUpdatorName})` : `${updatorName}`;

        const getFootPrintLength = () => {
            let lengthFootPrint = 0;
            if (footPrint?.length > 0) {
                lengthFootPrint = footPrint?.length > 100 ? '99+' : `${footPrint?.length}`;
            }

            return `${lengthFootPrint}`;
        };

        const onClickToViewTicket = async () => {
            if(!footPrint.includes(userDetail.id) && userDetail.id !== ticketKnowledge.creator){
                let footPrintClone = Utils.isEmptyArray(footPrint) ? [] : [...footPrint];
                footPrintClone.push(userDetail.id);
                setFootPrint([...footPrintClone])
            };

            return viewTicketKnowledgeDetail(
                argsCommon,
                ticketKnowledge.id,
                addNewPanel,
                setLastUserAction,
                true
            );
        };

        const handleFootprintPopover = async (e) => {
            await onHoverPopoverFootprint(
                e,
                ticketKnowledge,
                setFootPrintPopover,
                ticketKnowledgeList,
                setUserFootprintList,
                footPrint, 
                currentUserDetail
            );
        };

        return (
            <div className={`knowledge-item-container ${ticketKnowledge.id}`} key={ticketKnowledge.id}>
                <div className="knowledge-frame" key={ticketKnowledge.id}>
                    <div className="knowledge-head">
                        <div className="knowledge-head-absolute-wrap">
                            <Bookmark
                                isViewDelete={isViewDelete}
                                ticketKnowledge={ticketKnowledge}
                                isShowEdit={true}
                                isShowDefaultBookmark={false}
                            />
                            <TaggedBookmarkListName
                                bookmarkListText={ticketKnowledge?.bookmarkListText}
                                className="tagged-bookmark-knowledge-list-text"
                            />
                        </div>
                        <div className="knowledge-icon-frame knowledge-icon-frame-position-updated">
                            {hasKnowledgeChatPermission(ticketKnowledge, projectInuseDetail) &&
                                ticketKnowledge.public === Constant.TICKET_PUBLIC.PUBLIC && (
                                    <Badge
                                        overlap="rectangular"
                                        badgeContent={
                                            ticketKnowledge?.totalUnreadMsg > 0
                                                ? ticketKnowledge?.totalUnreadMsg
                                                : null
                                        }
                                        color="secondary"
                                        className="knowledge-chat-icon"
                                        onClick={() => openChatThreadPanel(ticketKnowledge)}
                                    >
                                        <img src="/assets/image/icon-chat.svg" alt="" />
                                    </Badge>
                                )}
                            <CopyShareLinkListItem
                                dataShareLink={dataShareLink}
                                publicStatus={ticketKnowledge.public}
                            />

                            {ticketKnowledge.public === Constant.TICKET_PUBLIC.PUBLIC &&
                                [
                                    Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
                                    Constant.USER_PERMISSION_VIEW_KNOWLEDGE.PERSONAL_PROJECT,
                                    Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER
                                ].includes(userPermissionView?.type) &&
                                projectInuseDetail.id === ticketKnowledge?.affiliationProject && (
                                    <div className="knowledge-btn">
                                        <div className="footprints ticket-outline">
                                            <Typography
                                                className="knowledge-footprint"
                                                aria-describedby={id}
                                                variant="inherit"
                                                onClick={handleFootprintPopover}
                                            >
                                                <span className="knowledge-item">
                                                    <img
                                                        src="/assets/image/icon-footprints.svg"
                                                        alt=""
                                                        className="knowledge-icon-frame-size"
                                                    />
                                                </span>
                                                <span className="number-count">
                                                    {getFootPrintLength()}
                                                </span>
                                            </Typography>
                                            {!Utils.isEmptyArray(footPrint) && (
                                                <Popover
                                                    className="numberView-sub"
                                                    id={idPopOverFootPrint}
                                                    open={openPopoverFootPrint}
                                                    anchorEl={footPrintPopover}
                                                    onClose={e => setFootPrintPopover(null)}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'center'
                                                    }}
                                                >
                                                    <div
                                                        className="listView"
                                                        id={`footprint_id_${ticketKnowledge.id}`}
                                                    >
                                                        <ul>{userFootprintList}</ul>
                                                    </div>
                                                </Popover>
                                            )}
                                        </div>
                                    </div>
                                )}

                            <div className="bookmark-count">
                                <Bookmark
                                    isViewDelete={isViewDelete}
                                    ticketKnowledge={ticketKnowledge}
                                    isShowEdit={false}
                                    isShowDefaultBookmark={true}
                                    tagDefaultBookmarkClassName={
                                        'reset-position-list-bookmark-icon'
                                    }
                                />
                                <span className="bookmark-count-number">
                                    {ticketKnowledge.totalPrivateBookmark >= 100
                                        ? '99+'
                                        : ticketKnowledge.totalPrivateBookmark}
                                </span>
                            </div>
                        </div>
                        <div className="knowledge-info">
                            <div
                                className="knowledgeTitle ticket-outline titleDisplay"
                                onClick={e => onClickToViewTicket()}
                            >
                                <Tooltip title={onDemandKnowledgeTitle}>
                                    <label
                                        className="titleDisplay titleTicket-titlev2 title-clamp"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {onDemandKnowledgeTitle}
                                    </label>
                                </Tooltip>
                                <OverFlowTooltipWithTabsMui
                                    value={projectName}
                                    className="knowledgeTitle-proj"
                                />
                            </div>
                        </div>
                        {permissionChangeShareRangeStatus(
                            ticketKnowledge,
                            userDetail,
                            isProjectManager,
                            projectInuseDetail,
                            viewStructure
                        ) && (
                            <div className="knowledge-share-status">
                                <Typography
                                    className="knowledge-share-status-label"
                                    aria-describedby={idPopoverShareStatus}
                                    variant="inherit"
                                    onClick={e =>
                                        handleClickShareStatus(
                                            e,
                                            ticketKnowledge,
                                            setShareStatusPopover,
                                            setOpenShareStatusPopover,
                                            argsCommon
                                        )
                                    }
                                    style={{
                                        marginTop: 10
                                    }}
                                >
                                    <span>{tr(`${labelOfButtonShareStatus}`)}</span>
                                </Typography>
                                <Popover
                                    className="share-status-popover"
                                    id={idPopoverShareStatus}
                                    key={`popover-share-status-${ticketKnowledge.id}`}
                                    open={openShareStatusPopover === ticketKnowledge.id}
                                    anchorEl={shareStatusPopover}
                                    onClose={e =>
                                        handleClosePopover(
                                            e,
                                            argsCommon,
                                            ticketKnowledge,
                                            shareStatusData
                                        )
                                    }
                                    anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'right'
                                    }}
                                >
                                    <div>
                                        <div
                                            className="listView knowledge-share-status-list"
                                            id={`share_status_id_${ticketKnowledge.id}`}
                                        >
                                            <FormControl
                                                component="fieldset"
                                                id={`form-control-share-status-${ticketKnowledge.id}`}
                                            >
                                                <FormGroup
                                                    aria-label="position"
                                                    className={`share-status-li share-status-li-checked`}
                                                    id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}-formGroup`}
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .CREATOR_ONLY
                                                        }
                                                        control={
                                                            <Checkbox
                                                                checked={true}
                                                                disabled={true}
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={
                                                            tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY)
                                                        }
                                                        labelPlacement={'end'}
                                                        id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}`}
                                                    />
                                                </FormGroup>
                                                <FormGroup
                                                    aria-label="position"
                                                    className={`share-status-li share-status-li-checked`}
                                                    id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT}-formGroup`}
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_PROJECT
                                                        }
                                                        control={
                                                            <Checkbox
                                                                checked={true}
                                                                disabled={true}
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={
                                                            tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT)
                                                        }
                                                        labelPlacement={'end'}
                                                        id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT}`}
                                                    />
                                                </FormGroup>
                                                <FormGroup
                                                    aria-label="position"
                                                    className={`share-status-li${
                                                        isCheckedChangeStatusOption(
                                                            Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                .IN_ORG,
                                                            argsCommon
                                                        )
                                                            ? ' share-status-li-checked'
                                                            : ''
                                                    }`}
                                                    id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_ORG}-formGroup`}
                                                    onChange={e =>
                                                        handleClickChecked(
                                                            e,
                                                            argsCommon,
                                                            Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                .IN_ORG
                                                        )
                                                    }
                                                    row
                                                >
                                                    <FormControlLabel
                                                        value={
                                                            Constant.KNOWLEDGE_TICKET_SHARE_STATUS
                                                                .IN_ORG
                                                        }
                                                        control={
                                                            <Checkbox
                                                                checked={isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .IN_ORG,
                                                                    argsCommon
                                                                )}
                                                                disabled={
                                                                    !Utils.isEmptyString(
                                                                        ticketKnowledge.deletedAt
                                                                    )
                                                                }
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={
                                                            tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_ORG)
                                                        }
                                                        labelPlacement={'end'}
                                                        id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_ORG}`}
                                                    />
                                                </FormGroup>
                                                {corporationDetail.deskService ===
                                                    Constant.STATUS_SERVICE_PERMISSION.ON && (
                                                    <>
                                                        <FormGroup
                                                            aria-label="position"
                                                            className={`share-status-li${
                                                                isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_CUSTOMER,
                                                                    argsCommon
                                                                )
                                                                    ? ' share-status-li-checked'
                                                                    : ''
                                                            }`}
                                                            id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_CUSTOMER}-formGroup`}
                                                            onChange={e =>
                                                                handleClickChecked(
                                                                    e,
                                                                    argsCommon,
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_CUSTOMER
                                                                )
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_CUSTOMER
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCheckedChangeStatusOption(
                                                                            Constant
                                                                                .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                                .B2B_CUSTOMER,
                                                                            argsCommon
                                                                        )}
                                                                        disabled={
                                                                            !Utils.isEmptyString(
                                                                                ticketKnowledge.deletedAt
                                                                            )
                                                                        }
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={
                                                                    tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_CUSTOMER)
                                                                }
                                                                labelPlacement={'end'}
                                                                id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_CUSTOMER}`}
                                                            />
                                                        </FormGroup>
                                                        <FormGroup
                                                            aria-label="position"
                                                            className={`share-status-li${
                                                                isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_SUPPORT,
                                                                    argsCommon
                                                                )
                                                                    ? ' share-status-li-checked'
                                                                    : ''
                                                            }`}
                                                            id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_SUPPORT}-formGroup`}
                                                            onChange={e =>
                                                                handleClickChecked(
                                                                    e,
                                                                    argsCommon,
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .B2B_SUPPORT
                                                                )
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .B2B_SUPPORT
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCheckedChangeStatusOption(
                                                                            Constant
                                                                                .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                                .B2B_SUPPORT,
                                                                            argsCommon
                                                                        )}
                                                                        disabled={
                                                                            !Utils.isEmptyString(
                                                                                ticketKnowledge.deletedAt
                                                                            )
                                                                        }
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={
                                                                    tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_SUPPORT)
                                                                }
                                                                labelPlacement={'end'}
                                                                id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_SUPPORT}`}
                                                            />
                                                        </FormGroup>

                                                        <FormGroup
                                                            aria-label="position"
                                                            className={`share-status-li${
                                                                isCheckedChangeStatusOption(
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .PUBLIC,
                                                                    argsCommon
                                                                )
                                                                    ? ' share-status-li-checked'
                                                                    : ''
                                                            }`}
                                                            id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.PUBLIC}-formGroup`}
                                                            onChange={e =>
                                                                handleClickChecked(
                                                                    e,
                                                                    argsCommon,
                                                                    Constant
                                                                        .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                        .PUBLIC
                                                                )
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={
                                                                    Constant
                                                                        .KNOWLEDGE_TICKET_SHARE_STATUS
                                                                        .PUBLIC
                                                                }
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCheckedChangeStatusOption(
                                                                            Constant
                                                                                .KNOWLEDGE_VIEW_EDIT_PERMISSION
                                                                                .PUBLIC,
                                                                            argsCommon
                                                                        )}
                                                                        disabled={
                                                                            !Utils.isEmptyString(
                                                                                ticketKnowledge.deletedAt
                                                                            )
                                                                        }
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={
                                                                    tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.PUBLIC)
                                                                }
                                                                labelPlacement={'end'}
                                                                id={`share-status-label-${ticketKnowledge.id}-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.PUBLIC}`}
                                                            />
                                                        </FormGroup>
                                                    </>
                                                )}
                                            </FormControl>
                                            {isAddtional && (
                                                <div
                                                    className="share-status-popover-additional"
                                                    onClick={e =>
                                                        viewTicketKnowledgeDetail(
                                                            argsCommon,
                                                            ticketKnowledge.id,
                                                            addNewPanel,
                                                            setLastUserAction,
                                                            true
                                                        )
                                                    }
                                                >
                                                    <span className="share-status-item-additional">
                                                        {
                                                            tr(Constant.KNOWLEDGE_SHARE_STATUS_LABEL_ADDITIONAL)
                                                        }
                                                    </span>
                                                    <span className="share-status-item-additional">
                                                        <img
                                                            src="/assets/image/share-status-additional.svg"
                                                            alt=""
                                                        />
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        )}
                    </div>
                    <div className="knowledge-content">
                        {isDisplayTicketThumbnail(ticketKnowledge) && (
                            <AttachThumbnailList
                                ticketDetail={ticketKnowledge}
                                panelType={Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST}
                                viewKey={props.listOnDemandKey || props.viewSelectedId}
                                projectInuseDetail={projectInuseDetail}
                                attachBadge={file => {
                                    const ticketType = Number(ticketKnowledge?.ticketType) || 0;
                                    if (![Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE, Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE].includes(ticketType)) return;
                                    const tag = displayTagOfThumbAttach(ticketKnowledge, file.fileName);
                                    return { badgeText: tag.name, badgeColor: tag.colorCode };
                                }}
                                options={(file, menuFile) => [
                                    {
                                        key: 'split-pdf',
                                        visible: Boolean(
                                            isShowIconPageUnit(ticketKnowledge, menuFile)
                                        ),
                                        content: (
                                            <ButtonOption
                                                onClick={() =>
                                                    handleSelectFilePdf(
                                                        setPreviousViewStructure,
                                                        setViewStructure,
                                                        viewStructure,
                                                        ticketKnowledge,
                                                        menuFile,
                                                        isCustomer,
                                                        setFileNamePdfSelect,
                                                        setTriggerSearch,
                                                        fileNamePdfSelect,
                                                        corporationSelectedId,
                                                        props.API,
                                                        setIsOpenModalReloadPage,
                                                        setIsLoading
                                                    )
                                                }
                                            >
                                                <span className="attach-file-thumbnail-option-label">
                                                    {trI18n('LABEL-SPLIT-PAGE-UNIT')}
                                                </span>
                                            </ButtonOption>
                                        )
                                    }
                                ]}
                            />
                        )}
                        <div className="knowledge-icon-frame">
                            {isDisplayEyeSlashIcon(
                                isCustomer,
                                visibilityKnowledgeAtom,
                                ticketKnowledge
                            ) && (
                                <div className="knowledge-btn-eye">
                                    <div className="chat">
                                        <span className="knowledge-item">
                                            <VisibilityOffIcon style={{ width: 16 }} />
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="knowledge-footer">
                        <div className="knowledge-lst">
                            <div>
                                 <p className="knowledge-date">{`${tr('作成日：')} ${formatUserDateTime(
                                    ticketKnowledge.createdAt,
                                    'YYYY/MM/DD',
                                    userDetail?.userSetting
                                )}`}</p>
                                <OverFlowTooltipWithTabsMui
                                    className="knowledge-name"
                                    value={creatorName}
                                />
                            </div>
                        </div>

                        <div className="knowledge-lst">
                            <div>
                               <p className="knowledge-date">{`${tr('更新日：')} ${formatUserDateTime(
                                    ticketKnowledge.updatedAt,
                                    'YYYY/MM/DD',
                                    userDetail?.userSetting
                                )}`}</p>
                                <OverFlowTooltipWithTabsMui
                                    className="knowledge-name"
                                    value={updatorName}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
